import React from 'react';

import ScrollableContainer from 'components/common/atoms/ScrollableContainer';
import StandardContentWrapper from 'components/common/atoms/StandardContentWrapper';
import PrivacyPolicy from 'components/common/templates/PrivacyPolicy';


function PrivacyPolicyModal() {
    return (
        <ScrollableContainer>
            <StandardContentWrapper>
                <PrivacyPolicy />
            </StandardContentWrapper>
        </ScrollableContainer>
    );
}

export default PrivacyPolicyModal;
